var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M497 0H15C6.715 0 0 6.715 0 15v397.445c0 8.285 6.715 15 15 15h482c8.285 0 15-6.715 15-15V15c0-8.285-6.715-15-15-15zM192.543 264.078v-100.71c0-7.204 4.11-13.77 10.723-17.138 6.718-3.417 14.894-2.96 21.113 1.11l85.828 50.101c.438.254.86.532 1.27.829 5.074 3.695 7.984 9.328 7.984 15.453s-2.91 11.757-7.984 15.453c-.41.297-.832.574-1.27.828l-85.828 50.101c-3.438 2.247-7.465 3.391-11.52 3.391-3.285 0-6.586-.754-9.593-2.285-6.618-3.363-10.723-9.93-10.723-17.133zM352.23 56.118V30h50.333v26.117zm-30 0h-50.335V30h50.335zm-80.335 0h-50.332V30h50.332zm-80.332 0H111.23V30h50.333zm0 315.21v26.117H111.23v-26.117zm30 0h50.332v26.117h-50.332zm80.332 0h50.335v26.117h-50.335zm80.335 0h50.333v26.117H352.23zM482 56.118h-49.438V30H482zM81.23 30v26.117H30V30zM30 371.328h51.23v26.117H30zm402.563 26.117v-26.117H482v26.117zm0 0",
    fill: "#81A63D",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.83fbdae5a201b3fecb7baff61c081413.svg";
export { ForwardRef as ReactComponent };